import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Row, Col, Form, Button } from "react-bootstrap";
import { PERMISSION_MAP as REPORT_PERMISSIONS_MAP } from "../../helpers/ReportPermission";
import DefaultConfig from '../../config/default';
import { Admin } from '../../api';

export const FFDAReportPermission = ({
    user, permissions,
    currentVAccount, onPermissionChange
}) => {
    // locationId = '' / Then it is the main vaccount
    const reportPermissions = useMemo(() => (
        // currentVAccount.locationId == null ?
            (REPORT_PERMISSIONS_MAP[DefaultConfig.DOMAIN_NAME] || [])
            // : []
    ), [currentVAccount]);
    const [ formData, setFormData ] = useState({});
    useEffect(() => {
        if (!reportPermissions || !currentVAccount) return setFormData({});
        const locationId = currentVAccount?.locationId || '';
        if (!permissions) return setFormData({});
        const vAccountPermission = permissions.find(p => p.chapel === locationId);
        const formData = {};
        if (!vAccountPermission) {
            setFormData(formData);
            return;
        }
        for (const permission of reportPermissions) {
            formData[permission.dbKey] = (vAccountPermission[permission.dbKey] === true);
        }
        setFormData(formData);
    }, [currentVAccount, reportPermissions, permissions])
    const handleUpdateBtn = async () => {
        const locationId = currentVAccount?.locationId || '';
        const vAccountPermission = permissions.find(p => p.chapel === locationId);
        onPermissionChange(currentVAccount.entityId, vAccountPermission.id, formData);
    };
    const handleSelectValue = (key, value) => {
        setFormData({
            ...formData,
            [key]: (value === 'true')
        });
        // onPermissionChange(key, value);
    };
    const safeFormData = formData || permissions;
    if (reportPermissions.length === 0) {
        return (
            <div className="text-center fw-bold">
                <p>There is not report available for this account.</p>
            </div>
        )
    }
    console.log('reportPermissions:', reportPermissions, safeFormData, permissions);
    return (
        <>
            <Row>
                <Col>
                    <Button variant="primary" onClick={handleUpdateBtn}>Save</Button>
                </Col>
            </Row>
            {reportPermissions.map((item, idx) => {
                // todo - remove when drive available for FFDA.
                if (DefaultConfig.DOMAIN_NAME === "FIDUCIAL_FEDERATED" && item.key.includes('drive'))
                    return <Fragment key={idx}></Fragment>
                if (item.isUsable && !item.isUsable(currentVAccount))
                    return <Fragment key={idx}></Fragment>
                return (
                    <Row key={idx} className="permission-field g-0 pt-2 pb-2">
                        <Col className="p-2 fw-bold" lg={4}>{item.label}</Col>
                        <Col lg={4}>
                            <Form.Select
                                disabled={user.isBusinessOwner}
                                onChange={(e) => handleSelectValue(item.key, e.target.value)}
                                value={safeFormData[item.key]}>
                                {
                                    item.choice.map((v, idx) => (
                                        <option key={idx} value={v.value}>{v.label}</option>
                                    ))
                                }
                            </Form.Select>
                        </Col>
                    </Row>
                );
            })}
        </>
    );
}